import { Modal } from 'bootstrap';
import { setDataAndShowDetailsModal } from 'static/components/details-modal/details-modal';
import { AdminEvent } from 'static/classes/Event';

export function ConversionViewModel(data){
    var self = this;
    self.type = "ConversionViewModel";

    self.rootvm = data.rootvm;
    self.internal_navigate = ko.observable(true);
    self.history_pop_subscribe;

    self.history_pop = function(options){
        // This will fire on no match
        if (options.route.length === 0 && self.initialized() && !self.internal_navigate() &&
            pager.activePage$().id() == 'invite-list') {
            // do the search here
            //console.log('history pop');
            //console.log('search query is ', self.search_query());
            self.lookup_events(false);
        }
        if(self.internal_navigate() == true){
            self.internal_navigate(false);
        }
        // scroll to the top
        $('html, body').scrollTop(0)
    }

    self.initialized = ko.observable(false);
    self.initialize = function(){
        if (self.offset() == undefined){
            self.offset(0);
        }
        if (self.limit() == undefined){
            self.limit(50);
        }

        const today = new Date();
        const sevenDaysAgo = new Date();
        sevenDaysAgo.setDate(today.getDate() - 7);
        self.start_date(sevenDaysAgo.toLocaleDateString('en-ca'));
        self.end_date(today.toLocaleDateString('en-ca'));

        self.history_pop_subscribe = pager.onNoMatch.add(self.history_pop);
        self.initialized(true);
    };

    self.afterHide = function(){
        self.history_pop_subscribe = pager.onNoMatch.remove(self.history_pop);
    }


    self.total_count = ko.observable();
    self.filtered_count = ko.observable();
    self.offset = ko.observable(0);
    self.limit = ko.observable(50);

    self.invite_stats = ko.observableArray([[0,0],[0,0], [0,0]]);

    self.selected_event_info = ko.observable(new AdminEvent({}));

    self.date_disable = ko.observable(false);

    self.events = ko.observableArray([]);

    self.event_actions = ko.observableArray(['confirmed', 'waiting_for_approval', 'waiting_for_confirmation', 'no_by_host', 'no_by_artist', 'cancelled']);
    self.event_categories = ko.observableArray([ 'sofaconcert', 'wedding', 'other', 'birthday', 'family_event', 'charity', 'contest', 'special_occassion', 'corporate_event', 'livestream', 'external']);


    self.filter_event_action = ko.observableArray([]);
    self.filter_event_category = ko.observableArray([]);
    self.selection = ko.observable('invitations');
    self.dateSearchType = ko.observable('event');

    self.error = ko.observable();
    self.search_query = ko.observable().extend({rateLimit: 500});

    self.search_query.subscribe(function(){
        if(self.search_query() != ""){
            self.date_disable(true);
        }
    });

    self.search_click = function(){
        //reset offset
        self.offset(0);
        self.lookup_events();
    }
    self.start_date = ko.observable();
    self.end_date = ko.observable();

    self.row_style = function(scevent){
        if(scevent.admin_closed()){
            return '';
        }
        if(scevent.current_state().event_state() == 'waiting_for_confirmation'){
            return 'table-warning';
        }
        else if(scevent.current_state().event_state() == 'waiting_for_approval'){
            return 'table-danger';
        }
        else if(scevent.current_state().event_state() == 'cancelled'){
            return 'table-info';
        }
        else if(scevent.current_state().event_state() == 'confirmed'){
            return 'table-success';
        }
        else{
            return '';
        }
    };

    self.create_navigation_string = function(){

        var navigation_string = ("#concerts/invite-list"
            + "?offset="
            + self.offset()
            + "&limit="
            + self.limit()
        );

        if(self.search_query()){
            navigation_string += "&search_query="
            + self.search_query()
        }

        if(self.selection()){
            navigation_string += "&selection="
            + self.selection();
        }

        if(self.dateSearchType()){
            navigation_string += "&dateSearchType="
            + self.dateSearchType();
        }

        if(self.filter_event_action()){

            ko.utils.arrayForEach(self.filter_event_action(), function(filter){
                navigation_string += "&filter_event_action[]="
                + filter;
            });
        }

        if(self.filter_event_category()){
            ko.utils.arrayForEach(self.filter_event_category(), function(filter){
                navigation_string += "&filter_event_category[]="
                + filter;
            });
        }

        if(self.start_date()){
            navigation_string += "&start_date="
            + self.start_date()
        }

        if(self.end_date()){
            navigation_string += "&end_date="
            + self.end_date()
        }

        return navigation_string;
    }

    self.lookup_events = async (set_internal_navigate = true) => {
        if (self.offset() == undefined || self.offset() === 'undefined') {
            self.offset(0);
        }
        if (self.limit() == undefined || self.limit() === 'undefined') {
            self.limit(50);
        }

        if (self.initialized && !self.rootvm.is_busy()) {
            self.rootvm.is_busy(true);
            try {
                const params = new URLSearchParams({
                    limit: self.limit(),
                    offset: self.offset(),
                    search: self.search_query(),
                    start_date: self.start_date(),
                    end_date: self.end_date(),
                    date_search_type: self.dateSearchType(),
                    selection: self.selection(),
                    date_disable: self.date_disable()
                });
                // Add array params manually
                self.filter_event_action()?.forEach(val => params.append('event_state[]', val));
                self.filter_event_category()?.forEach(val => params.append('event_type[]', val));


                const url = `${self.rootvm.web_host}/api/admin/events-for-conversion-rework?${params.toString()}`;
                const response = await fetch(url, {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json; charset=utf-8'
                    }
                });
                if (!response.ok) throw response;
                const data = await response.json();
                self.events(data.events?.map(event => {
                    console.log(event)
                    event.rootvm = self.rootvm;
                    return new AdminEvent(event);
                }) ?? []);
                self.total_count(data.total_count);
                self.filtered_count(data.filtered_count);
                self.rootvm.is_busy(false);
                const navigation_string = self.create_navigation_string();
                if (set_internal_navigate !== false) {
                    self.internal_navigate(true);
                }
                self.invite_stats(data.invite_stats);
                pager.navigate(navigation_string);
            } catch (err) {
                if (err.statusText) {
                    self.error(err.statusText);
                } else {
                    self.error('Network error');
                }
                self.events.removeAll();
                self.rootvm.is_busy(false);
            }
        }
    };

    self.set_selected_data = function (scevent, tabId) {
        setDataAndShowDetailsModal(scevent, tabId);
    };

    // Marketing source of the host, shown when the source icon is clicked.
    self.selected_acquisition_event = ko.observable();

    self.show_acquisition_details = function(scevent){
        self.selected_acquisition_event(scevent);
        const conAcquisitionModal = document.getElementById('conAcquisitionModal');
        Modal.getOrCreateInstance(conAcquisitionModal).show();
    };

    // TODO: check if we need both these functions
    self.event_bypass_header = ko.observable();
    self.set_event_message_allow_contact = function(scevent){
        console.log('setting allow contact');
        self.event_bypass_header('User said no Contact Data');
        self.selected_event_info(scevent);
        const conEventBypassModal = document.getElementById('conEventBypassModal');
        Modal.getOrCreateInstance(conEventBypassModal).show();
        self.selected_event_info().lookup_allow_contact();
        console.log("Show filter bypass modal")
    };

    self.set_event_message_filter_popup = function(scevent){
        console.log('setting messages pop up shown');
        self.event_bypass_header('User was shown pop up');
        self.selected_event_info(scevent);
        const conEventPopupShownModal = document.getElementById('conEventPopupShownModal');
        Modal.getOrCreateInstance(conEventPopupShownModal).show();
        self.selected_event_info().lookup_filter_popup_shown();
        console.log("Show filter bypass modal")
    };


    self.clear_filters = function(){
        const today = new Date();
        const sevenDaysAgo = new Date();
        sevenDaysAgo.setDate(today.getDate() - 7);
        self.filter_event_action([]);
        self.filter_event_category([]);
        self.start_date(sevenDaysAgo.toLocaleDateString('en-ca'));
        self.end_date(today.toLocaleDateString('en-ca'));
        self.dateSearchType('event');
        self.selection('invitations');
        self.search_query('');
        self.date_disable(false);
    };

    self.set_host_filter = function(scevent){
        self.filter_event_action([]);
        self.filter_event_category([]);
        self.start_date(undefined);
        self.end_date(undefined);
        self.dateSearchType('event');
        self.selection('all');
        /* PER CARO / LYDIA, always do creator uuid, in case we have
         * sofaconcert and other event type */
        if(scevent.initiator() == 'host'){
            self.search_query(scevent.creator_uuid())
        }
        else
        {
            self.search_query(scevent.host_uuid())
        }
        self.search_click();
    }

    self.set_artist_filter = function(scevent){
        self.filter_event_action([]);
        self.filter_event_category([]);
        self.start_date(undefined);
        self.end_date(undefined);
        self.dateSearchType('event');
        self.selection('all');
        self.search_query(scevent.artist_uuid())
        self.search_click();
    }

    self.get_artist_login_link = function(scevent){
        scevent.get_login_link("artist");
    };
    self.get_host_login_link = function(scevent){
        scevent.get_login_link("host");
    };

    self.lower_count_label = ko.computed(function(){
        return parseInt(self.offset()) + 1;
    });

    self.upper_count_label = ko.computed(function(){
        if (parseInt(self.limit()) + parseInt(self.offset()) > self.filtered_count())
        {
            return self.filtered_count();
        }
        else
        {
            return parseInt(self.limit()) + parseInt(self.offset());
        }
    });

    self.paging_visible = ko.computed(function () {
        return self.total_count() > 0;
    });

    self.next_button_visible = ko.computed(function() {
        return parseInt(self.offset()) + parseInt(self.limit()) < self.filtered_count();
    });

    self.previous_button_visible = ko.computed(function () {
        return parseInt(self.offset()) > 0;
    });



    self.go_left = function () {

        if (self.rootvm.is_busy()){
            return false;}

        self.offset(parseInt(self.offset()) - parseInt(self.limit()));

        self.lookup_events();

    };

    self.go_right = function () {

        if (self.rootvm.is_busy()){
            return false;}

        self.offset(parseInt(self.offset()) + parseInt(self.limit()));
        self.lookup_events();
    };
};
